import { CollectionStatus, CollectionType, DelivererStatus, FeeObjectType, FeeType, InternalSwitchStatus, SwitchStatus, TransactionDeliveredSubtypeType, TransactionDirectionType, TransactionType, UserStatus } from "types";
import { colors } from "./consts";
import Decimal from "decimal.js";
import { addSpacingToRIB } from "utils";

export const stringsToBooleans = (values: string[]): boolean[] => {
    return values.map(value => value.toLowerCase() === 'true');
};

export const statusesToBooleans = (values: UserStatus[] | DelivererStatus[]): boolean[] => {
    return values.map(value => value === UserStatus.ACTIVE || value === DelivererStatus.ACTIVE);
};

export const removeUnderScore = (str: string): string => {
    return str.replace(/_/g, ' ');
};

export const parseStatus = (staffMemberStatus: boolean): string => {
    switch (staffMemberStatus) {
        case true:
            return "ACTIF"
        case false:
            return "INACTIF"
        default:
            return "Erreur"
    }
};

export const getChipStatus = (status: boolean) => {
    switch (status) {
        case false:
            return {
                color: "#FF0000",
                backgroundColor: "#FFCCCC",
                borderRadius: "6px"
            };
        case true:
            return {
                color: colors.bold_green_secondary,
                backgroundColor: colors.light_green_secondary,
                borderRadius: "6px"
            };
        default:
            return {
                color: "#000000",
                backgroundColor: "#FFFFFF",
            }
    }
};

export const parseCollectionType = (status: CollectionType): string => {
    switch (status) {
        case CollectionType.CASH:
            return "Espèces"
        case CollectionType.QR_CODE:
            return "QR Code"
        default:
            return "N/A"
    }
};

export const parseCollectionStatus = (status: CollectionStatus): string => {
    switch (status) {
        case CollectionStatus.PAID:
            return "Payé"
        case CollectionStatus.REVERSED:
            return "Reversé"
        case CollectionStatus.NOT_PAID:
            return "À reverser"
        case CollectionStatus.CANCELED:
            return "Annulé"
        default:
            return "N/A"
    }
};

export const getCollectionStatusChipStyle = (status: CollectionStatus) => {
    switch (status) {
        case CollectionStatus.PAID:
        case CollectionStatus.REVERSED:
            return {
                color: colors.bold_green_secondary,
                backgroundColor: colors.light_green_secondary,
                borderRadius: "6px"
            };
        case CollectionStatus.NOT_PAID:
            return {
                color: "#F19920",
                backgroundColor: "#FEF5E9",
                borderRadius: "6px"
            };
        case CollectionStatus.CANCELED:
            return {
                color: "#FF0000",
                backgroundColor: "#FFCCCC",
                borderRadius: "6px"
            };
        default:
            return {
                color: "#000000",
                backgroundColor: "#FFFFFF",
            }
    }
};

export const getTransactionDeliveredSubtypeChipStyle = (deliveredSubtype: TransactionDeliveredSubtypeType) => {
    switch (deliveredSubtype) {
        case TransactionDeliveredSubtypeType.SUCCESS:
            return {
                color: colors.bold_green_secondary,
                backgroundColor: colors.light_green_secondary,
                borderRadius: "6px",
            }
        case TransactionDeliveredSubtypeType.CANCELED:
            return {
                color: "#FF0000",
                backgroundColor: "#FFCCCC",
                borderRadius: "6px"
            }
        default:
            return {
                color: "#000000",
                backgroundColor: "#FFFFFF",
            }
    }
};

export const parseTransactionDeliveredSubtype = (deliveredSubtype: TransactionDeliveredSubtypeType): string => {
    switch (deliveredSubtype) {
        case TransactionDeliveredSubtypeType.SUCCESS:
            return "Succès";
        case TransactionDeliveredSubtypeType.CANCELED:
            return "Annulée";
        default:
            return "Erreur";
    }
};

export const parseTransactionDirection = (status: TransactionDirectionType | string) => {
    switch (status) {
        case TransactionDirectionType.CREDIT:
        case 'Credit':
            return "Crédit";
        case TransactionDirectionType.DEBIT:
        case 'Debit':
            return "Débit";
        default:
            return "Erreur";
    };
};

export const parseTransactionType = (status: TransactionType | string) => {
    switch (status) {
        case TransactionType.CASH_IN_CASH:
        case 'CASHIN':
            return "Dépôt espèces";
        case TransactionType.CASH_OUT_CASH:
        case 'CASHOUT':
            return "Retrait espèces";
        case TransactionType.TRANSFER_SKYPAY_TO_SKYPAY:
            return "Transfert Skypay";
        case TransactionType.TRANSFER_SKYPAY_TO_BANK:
        case TransactionType.TRANSFER_BANK_TO_SKYPAY:
            return "Virement Bancaire";
        case TransactionType.TRANSFER_SKYPAY_TO_WALLET:
        case TransactionType.TRANSFER_WALLET_TO_SKYPAY:
            return "Transfert M-Wallet";
        case TransactionType.FEE_TRANSFER:
            return "Frais de transfert M-Wallet";
        case TransactionType.FEE_VE_WA_TO_RIB:
            return "Frais de virement";
        case TransactionType.FEE_CASHOUT:
            return "Frais de retrait";
        case TransactionType.FEE_MERCHANT_PAIEMENT:
        case TransactionType.FEE_MERCHANT_OFF_US:
            return "Frais de paiement";
        case TransactionType.MERCHANT_PAIEMENT_CREDIT:
        case TransactionType.MERCHANT_PAIEMENT_OFF_US_CREDIT:
            return "Paiement Reçu";
        default:
            return "Transaction";
    };
};

export const deleteAllOccurrences = (str: string, subStr: string) => {
    return str.replace(new RegExp(subStr, 'g'), '');
}

export const separatePhoneBy2digits = (value: string) => {

    const phoneNumber = deleteAllOccurrences(value, " ");
    const phoneNumberLength = phoneNumber.length;

    if (phoneNumberLength <= 2) return phoneNumber;
    else if (phoneNumberLength <= 4) {
        return `${phoneNumber.slice(0, 2)} ${phoneNumber.slice(2)}`;
    }
    else if (phoneNumberLength <= 6)
        return `${phoneNumber.slice(0, 2)} ${phoneNumber.slice(
            2,
            4
        )} ${phoneNumber.slice(4, 6)}`;
    else if (phoneNumberLength <= 8)
        return `${phoneNumber.slice(0, 2)} ${phoneNumber.slice(
            2,
            4
        )} ${phoneNumber.slice(4, 6)} ${phoneNumber.slice(6, 8)}`;
    return `${phoneNumber.slice(0, 2)} ${phoneNumber.slice(
        2,
        4
    )} ${phoneNumber.slice(4, 6)} ${phoneNumber.slice(
        6,
        8
    )} ${phoneNumber.slice(8, 10)}`;
}

export const isStringEmpty = (str: string | undefined) => str === undefined || str.length === 0;

export const checkNullable = (object: any, defaultValue: any) => (object === null || object === undefined || (typeof (object) === "string" && isStringEmpty(object))) ? defaultValue : object;

const formatComponent = (component: number): string => {
    return component < 10 ? `0${component}` : `${component}`;
};

export const formatDate = (inputDate: Date): string => {
    const months: string[] = [
        "Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet",
        "Août", "Septembre", "Octobre", "Novembre", "Décembre"
    ];

    const year: number = inputDate.getFullYear();
    const month: number = inputDate.getMonth();
    const day: number = inputDate.getDate();
    const hour: number = inputDate.getHours();
    const minute: number = inputDate.getMinutes();

    const monthName: string = months[month];
    const formattedHour: string = formatComponent(hour);
    const formattedMinute: string = formatComponent(minute);

    return `${day} ${monthName} ${year} à ${formattedHour}:${formattedMinute}`;
};

export const findMaxFinalAmount = (balanceInput: string, fees: FeeObjectType[]): number => {
    let maxFinalAmount = new Decimal(0);
    let balance = new Decimal(balanceInput);
    for (let i = 0; i < fees.length; i++) {
        let fee = fees[i];
        if (fee.feesType === FeeType.FIXED) {
            let maxOfIntervalTranslated = new Decimal(fee.max).plus(fee.firstValue);
            if (balance.greaterThanOrEqualTo(new Decimal(fee.min).plus(fee.firstValue)) && balance.lessThanOrEqualTo(maxOfIntervalTranslated)) {
                maxFinalAmount = Decimal.max(maxFinalAmount, balance.minus(fee.firstValue).floor())
            }
            else if (balance.greaterThan(maxOfIntervalTranslated))
                maxFinalAmount = Decimal.max(maxFinalAmount, fee.max)
        } else if (fee.feesType === FeeType.PERCENTAGE) {
            let maxOfIntervalTranslated = new Decimal(fee.firstValue).div(100).plus(1).mul(fee.max);
            if (balance.greaterThanOrEqualTo(new Decimal(fee.firstValue).div(100).plus(1).mul(fee.min)) &&
                balance.lessThanOrEqualTo(maxOfIntervalTranslated)) {
                maxFinalAmount = Decimal.max(maxFinalAmount, balance.div(new Decimal(fee.firstValue).div(100).plus(1)).floor())
            }
            else if (balance.greaterThan(maxOfIntervalTranslated))
                maxFinalAmount = Decimal.max(maxFinalAmount, fee.max)
        } else if (fee.feesType === FeeType.PERCENTAGE_AND_FIXED && fee.secondValue) {
            let maxOfIntervalTranslated = new Decimal(fee.firstValue).div(100).plus(1).mul(fee.max).plus(fee.secondValue);
            if (balance.greaterThanOrEqualTo(new Decimal(fee.firstValue).div(100).plus(1).mul(fee.min).plus(fee.secondValue)) &&
                balance.lessThanOrEqualTo(maxOfIntervalTranslated)) {
                maxFinalAmount = Decimal.max(maxFinalAmount, balance.minus(fee.secondValue).div(new Decimal(fee.firstValue).div(100).plus(1)).floor())
            }
            else if (balance.greaterThan(maxOfIntervalTranslated))
                maxFinalAmount = Decimal.max(maxFinalAmount, fee.max)
        }
    }
    return maxFinalAmount.toNumber();
}

//validFinalAmount Integer only
export const findAmountAndFee = (validFinalAmount: string, fees: FeeObjectType[], shouldRound?: {
    decimalPlaces: number,
    rounding: Decimal.Rounding,
}): {
    fee: string;
    amount: string;
} => {
    let isFound = false;
    let amountTemporary = new Decimal(Number.POSITIVE_INFINITY);
    let feeTemporary = new Decimal(-1);
    const amountValue = new Decimal(validFinalAmount);

    for (let i = 0; i < fees.length; i++) {
        const fee = fees[i];
        if (amountValue.greaterThanOrEqualTo(fee.min) && amountValue.lessThanOrEqualTo(fee.max)) {
            let currentFee = new Decimal(0);

            if (fee.feesType === FeeType.FIXED && fee.firstValue) {
                currentFee = new Decimal(fee.firstValue);
            } else if (fee.feesType === FeeType.PERCENTAGE && fee.firstValue) {
                currentFee = new Decimal(fee.firstValue).div(100).mul(amountValue);
            } else if (fee.feesType === FeeType.PERCENTAGE_AND_FIXED && fee.firstValue && fee.secondValue) {
                currentFee = new Decimal(fee.firstValue).div(100).mul(amountValue).plus(fee.secondValue)
            } else {
                //safe case
                return {
                    fee: "",
                    amount: ""
                };
            }

            currentFee = shouldRound ? currentFee.toDecimalPlaces(shouldRound.decimalPlaces, shouldRound.rounding) : currentFee;

            let calculatedAmount = amountValue.plus(currentFee);

            calculatedAmount = shouldRound ? calculatedAmount.toDecimalPlaces(shouldRound.decimalPlaces, shouldRound.rounding) : calculatedAmount

            if (amountTemporary.greaterThan(calculatedAmount)) {
                feeTemporary = currentFee;
                amountTemporary = calculatedAmount;
            }
            isFound = true;
        }
    }
    if (!isFound) {
        return {
            fee: "",
            amount: ""
        };
    }
    return {
        fee: feeTemporary.toString(),
        amount: amountTemporary.toString()
    };
};

export const getSwitchStatusByCode = (code: string) => {
    switch (code) {
        case "00": return SwitchStatus.UNENROLLED
        case "01": return SwitchStatus.ACTIF;
        case "02": return SwitchStatus.INACTIF;
        default: return SwitchStatus.UNKNOWN;
    }
}

export const getSwitchStatusLabel = (status: SwitchStatus) => {
    switch (status) {
        case SwitchStatus.ACTIF: return "Actif";
        case SwitchStatus.INACTIF: return "Inactif";
        case SwitchStatus.UNENROLLED: return "Non enregistré";
        case SwitchStatus.UNKNOWN: return "Inconnu";
    }
};
export const getInternalSwitchStatusLabel = (status: InternalSwitchStatus) => {
    switch (status) {
        case InternalSwitchStatus.ACTIVE: return "Actif";
        case InternalSwitchStatus.NOTACTIVE: default: return "Inactif";
    }
};

export const transactionTargetByPhonenumber = (target?: string, targetName?: string) => targetName || separatePhoneBy2digits(target || '');

export const transactionTargetByRIB = (target?: string, targetName?: string) => targetName || addSpacingToRIB(target || '');

export const addOneDay = (day: Date | undefined) => {
    if (day) {
        const newDay = new Date(day);
        newDay.setDate(day.getDate() + 1);
        return newDay;
    }
};

export const checkDates = (dates: [Date | undefined, Date | undefined]): null | [Date | undefined, Date | undefined] => {
    if (dates[0] === undefined && dates[1] === undefined) {
        return null;
    }
    else return dates;
}

export const getLastWeek = (): [Date, Date] => {
    const endDate = new Date();
    const startDate = new Date(endDate);
    startDate.setDate(endDate.getDate() - 6);
    return [startDate, endDate];
}